import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=08f0860d&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Layout.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout.vue
// module id = 1636
// module chunks = 1